import React from 'react';

import ForecastsSidebar from '../components/forecasts/ForecastsSidebar';
import ForecastsContent from '../components/forecasts/ForecastsContent';

const KpiForecasts = () => (
  <div className="kpi-forecasts kpi-forecasts-reports">
    <div className="kpi-forecasts-block">
      <ForecastsSidebar />
      <ForecastsContent />
    </div>
  </div>
);

export default KpiForecasts;
